import { useQuery } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS } from '@src/query';
import { getSuggestions } from './api';

export const useQuerySuggestions = (fileName: string) => 
  useQuery({
    queryKey: [DEPRECATED_QUERY_KEYS.PRODUCTS, fileName],
    queryFn: async () => {
      if (!fileName) {
        return {
          suggestions: [],
          hasEmbeddings: false,
        };
      }
      return getSuggestions({
        fileName,
      });
    }
  });
